import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {CommonService} from './../../../_services/common.service';
import {HttpRequestService} from './../../../_services/http-request.service';
import { ToastrService } from 'ngx-toastr';
import {ActivatedRoute, Router} from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {PicturepathPipe} from '../../../shared/pipe/picturepath.pipe'; 
@Component({
  selector: 'app-topic-details',
  templateUrl: './topic-details.component.html',
  styleUrls: ['./topic-details.component.scss'],
  providers:[
    PicturepathPipe
  ]
})
export class TopicDetailsComponent implements OnInit {
  @ViewChild('videocontent', {static: false})videocontent: ElementRef;
  topicDetails:any = {};
  constructor(public translate: TranslateService,private cService: CommonService,
    private httpService: HttpRequestService, private toastr: ToastrService,
    private activatedRoute:ActivatedRoute, private router:Router,
    private title: Title, private meta: Meta,
    private modalService: NgbModal,
    private picturePath:PicturepathPipe
    ) {
      this.cService.activelang.subscribe((lang) => {
      
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang(lang);
  
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use(lang);
      });
  
    }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params)=>{
      let slug = params.slug;
      this.httpService.setModule('action').post('topic_details',{
        slug : slug
      }).subscribe((response) => {
        
        if (response.status=='success') {
         this.topicDetails = response.data;
         this.topicDetails.localData = response.data.local[0];
         this.title.setTitle(response.data.local[0].meta_title);
         this.meta.updateTag({ name: 'og:title', content: this.topicDetails.localData.meta_title })
         this.meta.updateTag({ name: 'og:keyword', content: this.topicDetails.localData.meta_keyword })
         this.meta.updateTag({ name: 'og:description', content: this.topicDetails.localData.meta_description })

         this.topicDetails.articleList = [];
         if (this.topicDetails.article && this.topicDetails.article.length>0 ) {
          for (let articleIndex=0; articleIndex<this.topicDetails.article.length; articleIndex++ ) {
            let article = this.topicDetails.article[articleIndex];
            if (!this.topicDetails.articleList[article.article_category.slug]) {
              this.topicDetails.articleList[article.article_category.slug] = {
                'title':'',
                'slug':'',
                'article':[]
              };
            }
            this.topicDetails.articleList[article.article_category.slug].title = article.article_category.local[0].title;

            this.topicDetails.articleList[article.article_category.slug].slug = article.article_category.slug;
            this.topicDetails.articleList[article.article_category.slug]['article'].push(
              {
                'title':article.local[0].title,
                'slug':article.slug,
                'published_at':article.published_at
              }
            )
          }
         }
         this.topicDetails.articleList = Object.values(this.topicDetails.articleList);
        }
        if (response.status=='error') {
          this.toastr.error( response.message,'Error');
        }
      }, (error) => {
        console.log(error);
      });
    });
  }

  goToEventGroup(eventGroup) {
    document.getElementById(eventGroup).scrollIntoView();
  }

  openVideoModal(content, video) {
    // console.log(video);
    this.modalService.open(content, { size:'xl',  centered: true });
    document.getElementById('videoTitle').innerText = video.local[0].title;
    document.getElementById('videoDescription').innerText = video.local[0].description; 
    document.getElementById('videoIfream').setAttribute('src', 'https://www.youtube.com/embed/'+video.video_code); 
  }

  // openVideoModal(videocontent, video) {
  //   this.modalService.open(videocontent, { size: 'xl', backdrop: 'static', centered: true }).result.then((result) => {
  //     console.log('ddddd');
  //     document.getElementById('videoThumb').setAttribute('src', this.picturePath.transform(video.video_code, 'video')); 
      
  //   }, (reason) => {

  //   });
  // }
}
